<template>
  <div class="block_screen">
    <img class="img-center" src="assets/create_screens/scr3.png" alt="">
    <a data-name="microsoft windows PE" @click.prevent="changeScreen(77)" class="flash_buttons сd-btn3" href=""></a>
    <a data-name="linux" @click.prevent="changeScreen(84)" class="flash_buttons сd-btn33" href=""></a>
    <a class="flash_buttons" href=""></a>
    <div class="btn_left">
      <a data-name="back" href="" @click.prevent="changeScreen(0)"
         class="btn btn_orange">Back</a>
    </div>
  </div>
</template>
<script>
  import {mapMutations} from 'vuex'
  import $ from 'jquery'
  export default {
    mounted() {
      $.each($('.flash_buttons'), function(i, el) {
        setTimeout(function() {
          $(el).toggleClass("active");
          $(el).prev().toggleClass("active");
        }, 1000 + (i * 500));

      });
    },
    methods: {
      ...mapMutations({
        changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
      })
    },
  };
</script>
<style type="text/css">
  .сd-btn3 {
    position: absolute;
    top: 112px;
    left: 394px;
    width: 668px;
    height: 90px;
  }
  .сd-btn33 {
    position: absolute;
    top: 202px;
    left: 394px;
    width: 668px;
    height: 90px;
  }
</style>
